

import {  BufferWindowMemory } from "langchain/memory";
import getuser from "../aws_utils/getAuthuser";
import { addProjectChat } from "../apigateway/mongocalls";
import { invokeSearchAgentApi } from "../apigateway/agentcalls";

export default async function generalagent(query, projectname, projectconversation) {

    if(projectname === "" || projectname === undefined){
        alert("Select or Start New Project!")
        return
    }

  

let userid = ""
try {
    const user = await getuser()
    userid = user.username
} catch (error) {
    console.log(error)
}

// console.log('project convo', projectconversation)
   
    // Buffer Window Memory
    const memory = new BufferWindowMemory();

    // Attempts to add memery
    // const userchat = await getProjectChats(projectname, authtoken)
    if(projectconversation.length === 0){
        // console.log("No User Chats!")
        } else {
        
        // console.log("User Chats Exist!")
        projectconversation.forEach(async item => {
            // console.log("Query", item.query)
            // console.log("Response", item.response)
            
            if(item.query === null){
            await memory.saveContext(
                {input: "..."},
                {output: item.response}
            )
            return
            }
    
            if(item.response === null){
                // console.log("2")
            await memory.saveContext(
                {input: item.query},
                {output: "..."},
                )
                return
            }
    
            await memory.saveContext(
                {input: item.query},
                {output: item.response},
            )
    
            });
        }
    
    // console.log("Conversation Memory", memory)

    // const history = await memory.loadMemoryVariables({});
    const messages = await memory.chatHistory.getMessages();
     const basemessages = memory.chatHistory.messages

    // console.log("history", history.history)
    // console.log("Messages", messages)
   

    const serializeChatHistory = async (chatHistory) => {
        let aiCount = 0;
        let humanCount = 0;
        const serializedMessages = chatHistory.map((chatMessage) => {
            if (chatMessage._getType() === "human" && humanCount < 5) {
                humanCount++;
                return `Human: ${chatMessage.content}`;
            } else if (chatMessage._getType() === "ai" && aiCount < 5) {
                aiCount++;
                return `Assistant: ${chatMessage.content}`;
            } else {
                return null;
            }
        }).filter(message => message !== null)
        return serializedMessages;
    }
    // .join("\n");
    
    
    const oldmem = await serializeChatHistory(messages)
    const recentmem = await serializeChatHistory(basemessages.reverse());
    

    const sumupmemory = { 
        "____OLDEST CHAT HISTORY____": oldmem,
        "____MOST RECENT CHAT HISTORY____": recentmem.reverse(),   
    }
    const memorysummary = JSON.stringify(sumupmemory)

   
    // Invoke Search Agent Api
    const resp = await invokeSearchAgentApi(query, memorysummary);


    const response = resp

    let finalresp 
    if(response === `error`){
        finalresp = `Request Timed Out... Try query again`
    }
    if(response === null || response === undefined || response === ''){
        finalresp = `Try rephrasing or simiplifying your query!`  
    } 
    if(response === `Agent stopped due to max iterations.`){
        finalresp = `Try rephrasing or simiplifying your query!`
    } 
    if(response !== null && response !== `error` && response !== `Agent stopped due to max iterations.`){
        finalresp = response
    }


    // console.log('final resp', finalresp)
    // Push to DB
    const addChatPackage = {
        "project": projectname,
        "userId": userid,
        "query": query,
        "response" : finalresp,  
        "agent" : "search agent"
    }

    const result = await addProjectChat(addChatPackage)
    const output = {
    "result": result,
    "response": finalresp,
    }
    // console.log('output', output);
    return output


}
